/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ fee: NonNullable<unknown> }} Pricing_Free_DescriptionInputs */

const en_pricing_free_description = /** @type {(inputs: Pricing_Free_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Launch your SSC subpath, sell up to 50 listings. ${i?.fee}% platform fee.`)
};

const es_pricing_free_description = /** @type {(inputs: Pricing_Free_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lanza tu subdominio SSC, vende hasta 20 anuncios. ${i?.fee}% de comisión de plataforma.`)
};

const fr_pricing_free_description = /** @type {(inputs: Pricing_Free_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lancez votre sous-domaine SSC, vendez jusqu'à 20 annonces. ${i?.fee} % de frais de plateforme.`)
};

const de_pricing_free_description = /** @type {(inputs: Pricing_Free_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Starte deinen SSC-Unterpfad, verkaufe bis zu 20 Inserate. ${i?.fee}% Plattformgebühr.`)
};

const ja_pricing_free_description = /** @type {(inputs: Pricing_Free_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`SSCのサブパスで立ち上げ、最大20件まで出品可能。プラットフォーム手数料${i?.fee}%。`)
};

const zh_pricing_free_description = /** @type {(inputs: Pricing_Free_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`启动您的 SSC 子域名店铺，最多可上架 20 个商品。${i?.fee}% 平台费。`)
};

const ar_pricing_free_description = /** @type {(inputs: Pricing_Free_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`أطلق مسارك الفرعي على SSC، وقم ببيع ما يصل إلى 20 إعلاناً. رسوم منصة ${i?.fee}%.`)
};

const id_pricing_free_description = /** @type {(inputs: Pricing_Free_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Luncurkan subpath SSC Anda, jual hingga 50 listing. Biaya platform ${i?.fee}%.`)
};

const it_pricing_free_description = /** @type {(inputs: Pricing_Free_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lancia il tuo sottopercorso SSC, vendi fino a 20 annunci. Commissione di piattaforma ${i?.fee}%.`)
};

const ru_pricing_free_description = /** @type {(inputs: Pricing_Free_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Запустите магазин на поддомене SSC, продавайте до 20 товаров. Комиссия платформы ${i?.fee}%.`)
};

const pt_pricing_free_description = /** @type {(inputs: Pricing_Free_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lance seu subdomínio SSC, venda até 20 anúncios. ${i?.fee}% de taxa de plataforma.`)
};

const ko_pricing_free_description = /** @type {(inputs: Pricing_Free_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`SSC 서브도메인으로 시작하고 최대 20개의 상품을 판매하세요. 플랫폼 수수료 ${i?.fee}%.`)
};

/**
* | output |
* | --- |
* | "Launch your SSC subpath, sell up to 50 listings. {fee}% platform fee." |
*
* @param {Pricing_Free_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const pricing_free_description = /** @type {((inputs: Pricing_Free_DescriptionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Free_DescriptionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_free_description(inputs)
	if (locale === "es") return es_pricing_free_description(inputs)
	if (locale === "fr") return fr_pricing_free_description(inputs)
	if (locale === "de") return de_pricing_free_description(inputs)
	if (locale === "ja") return ja_pricing_free_description(inputs)
	if (locale === "zh") return zh_pricing_free_description(inputs)
	if (locale === "ar") return ar_pricing_free_description(inputs)
	if (locale === "id") return id_pricing_free_description(inputs)
	if (locale === "it") return it_pricing_free_description(inputs)
	if (locale === "ru") return ru_pricing_free_description(inputs)
	if (locale === "pt") return pt_pricing_free_description(inputs)
	return ko_pricing_free_description(inputs)
});